import { render, staticRenderFns } from "./nbuniqueviewerscard.vue?vue&type=template&id=96b92644&scoped=true&"
import script from "./nbuniqueviewerscard.vue?vue&type=script&lang=js&"
export * from "./nbuniqueviewerscard.vue?vue&type=script&lang=js&"
import style0 from "./nbuniqueviewerscard.vue?vue&type=style&index=0&id=96b92644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b92644",
  null
  
)

export default component.exports